export default class UserAuthorizationService {
  static storagekey = {
    userName: 'foxrenderfarm_userName',
    userId: 'foxrenderfarm_userId',
  }
  static getUserName() {
    if (typeof window !== 'undefined') {
      const userName = window.sessionStorage.getItem(UserAuthorizationService.storagekey.userName)
      return userName ? JSON.parse(userName) : ''
    }
    return ''
  }
  static setUserName(userName: string) {
    if (typeof window !== 'undefined') {
      window.sessionStorage.setItem(
        UserAuthorizationService.storagekey.userName,
        JSON.stringify(userName),
      )
    }
  }
  static removeUserName() {
    if (typeof window !== 'undefined') {
      window.sessionStorage.removeItem(UserAuthorizationService.storagekey.userName)
    }
  }
  static isLogined() {
    return !!UserAuthorizationService.getUserName()
  }
  static getUserId() {
    if (typeof window !== 'undefined') {
      const userId = window.sessionStorage.getItem(UserAuthorizationService.storagekey.userId)
      return userId ? JSON.parse(userId) : ''
    }
    return ''
  }

  static setUserId(userId: number) {
    if (typeof window !== 'undefined') {
      window.sessionStorage.setItem(
        UserAuthorizationService.storagekey.userId,
        JSON.stringify(userId),
      )
    }
  }
  static removeUserId() {
    if (typeof window !== 'undefined') {
      window.sessionStorage.removeItem(UserAuthorizationService.storagekey.userId)
    }
  }
}
